import { render, staticRenderFns } from "./EmergencyTrainings.vue?vue&type=template&id=131fc1e7&scoped=true&"
import script from "./EmergencyTrainings.vue?vue&type=script&lang=js&"
export * from "./EmergencyTrainings.vue?vue&type=script&lang=js&"
import style0 from "./EmergencyTrainings.vue?vue&type=style&index=0&id=131fc1e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131fc1e7",
  null
  
)

export default component.exports